import {
  LOGIN_CODES_INDEX_REQUESTED,
  LOGIN_CODES_INDEX_SUCCESS,
  LOGIN_CODES_INDEX_FAILURE,
  LOGIN_CODE_CREATE_REQUESTED,
  LOGIN_CODE_CREATE_SUCCESS,
  LOGIN_CODE_CREATE_FAILURE,
  LOGIN_CODE_UPDATE_REQUESTED,
  LOGIN_CODE_UPDATE_SUCCESS,
  LOGIN_CODE_UPDATE_FAILURE,
  LOGIN_CODE_DELETE_REQUESTED,
  LOGIN_CODE_DELETE_SUCCESS,
  LOGIN_CODE_DELETE_FAILURE,
} from '../types';

const INITIAL_STATE = {
  loginCodes: [],
  isFetching: false,
  isCreating: false,
  updatingLoginCode: null,
  deletingLoginCode: null,
  status: 'waiting',
  errors: null
};

const loginCodes = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case LOGIN_CODES_INDEX_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        status: 'requesting'
      })

    case LOGIN_CODES_INDEX_SUCCESS:
      return Object.assign({}, state, {
        loginCodes: action.payload.login_codes || [],
        isFetching: false,
        status: 'success',
        errors: null
      })

    case LOGIN_CODES_INDEX_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'waiting',
        errors: 'Could not load login codes'
      })

    case LOGIN_CODE_CREATE_REQUESTED:
      return Object.assign({}, state, {
        isCreating: true,
        errors: null
      })

    case LOGIN_CODE_CREATE_SUCCESS:
      return Object.assign({}, state, {
        loginCodes: action.payload.login_code ? [...state.loginCodes, action.payload] : state.loginCodes,
        isCreating: false,
        status: 'success',
        errors: null
      })

    case LOGIN_CODE_CREATE_FAILURE:
      return Object.assign({}, state, {
        isCreating: false,
        errors: 'Could not create login code'
      })

    case LOGIN_CODE_UPDATE_REQUESTED:
      return Object.assign({}, state, {
        updatingLoginCode: action.loginCode,
        errors: null
      })

    case LOGIN_CODE_UPDATE_SUCCESS:
      return Object.assign({}, state, {
        loginCodes: action.payload.login_code
          ? state.loginCodes.map((loginCode) => loginCode.login_code === action.payload.login_code ? action.payload : loginCode)
          : state.loginCodes,
        updatingLoginCode: null,
        status: 'success',
        errors: null
      })

    case LOGIN_CODE_UPDATE_FAILURE:
      return Object.assign({}, state, {
        updatingLoginCode: null,
        errors: 'Could not update login code'
      })

    case LOGIN_CODE_DELETE_REQUESTED:
      return Object.assign({}, state, {
        deletingLoginCode: action.loginCode,
        errors: null
      })

    case LOGIN_CODE_DELETE_SUCCESS:
      return Object.assign({}, state, {
        loginCodes: state.loginCodes.filter((loginCode) => loginCode.login_code !== action.payload),
        deletingLoginCode: null,
        status: 'success',
        errors: null
      })

    case LOGIN_CODE_DELETE_FAILURE:
      return Object.assign({}, state, {
        deletingLoginCode: null,
        errors: 'Could not delete login code'
      })

    default:
      return state;
  }
}

export default loginCodes;
